import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { translate } from 'react-i18next';
import { observer, inject } from 'mobx-react';
import BrowserPopUp from '../BrowserPopUp/BrowserPopUp';
import SnackStore from '../../stores/SnackStore';
import { ClearCookiesStoreProp } from '../../stores/props';
import { FTBody } from '../Fuse';
import ClearCookiesModalOld from './ClearCookiesModalOld';
import { isFuse5Enabled } from '../../fuseFeatureFlag';
import FuseButton from '../FuseControls/FuseButton';

function ClearCookiesNotification({ t, clearCookies, snack, onRefresh }) {
    const actions = <Fragment>
        <FuseButton
            role="button"
            type={FuseButton.type.SECONDARY}
            color={FuseButton.color.BLUE}
            onClick={clearCookies.modal.close}
            disabled={clearCookies.isApiCallLoading}
        >{t('clearCookiesModal.cancel')}</FuseButton>
        <FuseButton
            role="button"
            type={FuseButton.type.PRIMARY}
            color={FuseButton.color.BLUE}
            onClick={() => clearCookies.doClearCookies(() => {
                // TODO: do refresh on store level
                onRefresh();
                snack.showSnack({ type: 'success', content: t('clearCookiesModal.success') });
            })}
            loading={clearCookies.isApiCallLoading}
        >{t('clearCookiesModal.ok')}</FuseButton>
    </Fragment>;
    return <BrowserPopUp
        isOpen={clearCookies.modal.isOpen}
        onRequestClose={() => clearCookies.modal.close()}
        title={t('clearCookiesModal.title')}
        footerActions={actions}
    >
        <FTBody>{t('clearCookiesModal.text.template')}</FTBody>
    </BrowserPopUp>;
}

ClearCookiesNotification.propTypes = {
    t: PropTypes.func.isRequired,
    onRefresh: PropTypes.func.isRequired,
    clearCookies: ClearCookiesStoreProp,
    snack: SnackStore.PropType.isRequired,
};

const ClearCookiesModal = () => {
    const ObservableClearCookiesModal = translate()(inject(
        'clearCookies',
        'snack',
    )(observer(ClearCookiesNotification)));
    return isFuse5Enabled() ? <ObservableClearCookiesModal /> : <ClearCookiesModalOld />;
};

export default ClearCookiesModal;
